import { Stack } from '@mui/joy'
import { rentalContractQuantityOfHoursLabels } from '~/shared/config/constants'
import { RentalContractQuantityOfHoursEnum } from '~/shared/config/enums'
import { AsyncGridColumns, ColumnDate, ColumnLink } from '~/shared/ui/AsyncGrid'
import { ChipStatus } from '~/shared/ui/Chips'
import { RentalContractPaymentSchedule } from '~/widgets/common/Driver/RentalContractControls'
import { Print } from '../Print'
import { Actions } from './Actions'
import { GridRow } from './types'

export const useColumns = (canActions = true): AsyncGridColumns<GridRow> => [
  {
    headerName: 'column.contract number',
    field: 'contractNumber',
    sortable: false,
    minWidth: 200,
    renderCell: ({ row }) => (
      <ColumnLink to={row.id}>{row.contractNumber}</ColumnLink>
    ),
  },
  {
    headerName: 'column.contract start date',
    field: 'createdAt',
    sortable: false,
    minWidth: 160,
    renderCell: ({ row }) => <ColumnDate type='date' value={row.createdAt} />,
  },
  {
    headerName: 'column.contract termination date',
    field: 'terminationDate',
    sortable: false,
    minWidth: 160,
    renderCell: ({ row }) => (
      <ColumnDate type='date' value={row.terminationDate} />
    ),
  },
  {
    headerName: 'column.license plate number',
    field: 'plateNumber',
    sortable: false,
    minWidth: 140,
  },
  {
    headerName: 'column.lessor',
    field: 'carRentalName',
    sortable: false,
    minWidth: 230,
    flex: 1,
  },
  {
    headerName: 'column.status',
    field: 'statusObj',
    sortable: false,
    minWidth: 180,
    renderCell: ({ value }) => (
      <ChipStatus labelI18n={value.label} variant={value.color} />
    ),
  },
  {
    headerName: 'column.actions',
    field: 'actions',
    sortable: false,
    minWidth: 260,
    renderCell: ({ row }) => (
      <Stack
        direction='row'
        alignItems='center'
        flexWrap='wrap'
        data-testid='car-rental-contracts-actions'
      >
        {canActions && (
          <Actions status={row.status} rentalContractId={row.id} />
        )}

        <RentalContractPaymentSchedule isIcon rentalContractId={row.id} />

        <Print filepath={row.filepath} />
      </Stack>
    ),
  },
  {
    headerName: 'column.price is changed manually',
    minWidth: 200,
    sortable: false,
    field: 'priceChangedManually',
    renderCell: ({ value }) => (
      <ChipStatus
        labelI18n={value ? 'column.yes' : 'column.no'}
        variant={value ? 'purple' : 'gray'}
      />
    ),
  },
  {
    headerName: 'column.quantity rental payments',
    field: 'quantityRentalPayments',
    sortable: false,
    minWidth: 200,
    renderCell: ({ value }) => (
      <ChipStatus
        labelI18n={
          value
            ? rentalContractQuantityOfHoursLabels[
                value as RentalContractQuantityOfHoursEnum
              ]
            : 'form.every 2 hours'
        }
        variant='gray'
      />
    ),
  },
]
